import { useEffect, useRef, useMemo } from 'react';
import { NAME_ATTRIBUTE, __DEPRECATED_RENDER_EVENT, MOUNT_OR_UPDATE_EVENT, UNMOUNT_EVENT } from './constants';
export default function useCorssAppID(name) {
  let {
    disabled = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const events = useRef({});
  const update = useMemo(() => () => {
    if (disabled) return;
    const {
      deprecatedEvent,
      mountOrUpdateEvent
    } = events.current;
    document.dispatchEvent(deprecatedEvent); // Deprecated
    document.dispatchEvent(mountOrUpdateEvent);
  }, [disabled]);
  useEffect(() => {
    const info = {
      detail: {
        name
      }
    };
    const deprecatedEvent = new CustomEvent(__DEPRECATED_RENDER_EVENT, info); // Deprecated
    const mountOrUpdateEvent = new CustomEvent(MOUNT_OR_UPDATE_EVENT, info);
    const unmountEvent = new CustomEvent(UNMOUNT_EVENT, info);
    events.current = {
      deprecatedEvent,
      mountOrUpdateEvent
    };
    update();
    return () => {
      if (disabled) return;
      document.dispatchEvent(unmountEvent);
    };
  }, [disabled, events, name, update]);
  return [disabled ? {} : {
    [NAME_ATTRIBUTE]: name
  }, update];
}